
export default {
    props: {
        soa: {
            type: Object,
            default: null
        },
        client: {
            type: Object,
            default: null
        },
        soa60days: {
            type: [String, Object],
            default: null
        }
    }
}
